import React from 'react'

const Label = props => {
  const { htmlFor, text } = props
  return <label htmlFor={htmlFor} className="block font-medium text-gray-800 mb-1">{text}</label>
}

export default Label
